import userApi from "~/api/user";

const fetchUsers = ({ commit, state }) => {
  if (state.fetchingUsers === false && state.users.length === 0) {
    commit("SET_FETCHING_USERS", true);

    userApi
      .paginateActive(1, 1000)
      .then((response) => {
        commit("SET_USERS", response.data);
      })
      .finally(() => {
        commit("SET_FETCHING_USERS", false);
      });
  }
};

const setUsers = (context, users) => {
  context.commit("SET_USERS", users);
};

const getUserById = async (context, userId) => {
  if (context.state.fetchingUsersIds.indexOf(userId) !== -1
    || context.getters.hasUserById(userId)) {
    return Promise.resolve(context.getters.getUserById(userId));
  }

  context.commit("SET_FETCHING_USER_IDS", [userId]);

  return userApi.getUserById(userId)
    .then((response) => {
      context.commit("UNSET_FETCHING_USER_IDS", [userId]);
      context.commit("CACHE_USER", response.data);

      return response.data;
    });
};

const fetchUsersByIds = async (context, userIds) => {
  const filteredUserIds = userIds
    .filter((userId) => context.state.fetchingUsersIds.indexOf(userId) === -1)
    .filter((userId) => !context.getters.hasUserById(userId));

  if (filteredUserIds.length === 0) {
    return Promise.resolve();
  }

  context.commit("SET_FETCHING_USER_IDS", filteredUserIds);

  return userApi.getUsersByIds(filteredUserIds)
    .then((response) => {
      context.commit("UNSET_FETCHING_USER_IDS", filteredUserIds);
      context.commit("CACHE_USERS", response.data);

      return response.data;
    });
};

export default {
  fetchUsers,
  setUsers,
  getUserById,
  fetchUsersByIds,
};
